module.exports = __webpack_public_path__ + "media/images/p-about/about/fund-05f4c4a0d7d30d7529d3c467c3dff18c.svg";